import React from 'react';
import { observer } from 'mobx-react';

// import { SimpleInput, Button } from 'components/atoms';

import { Container } from './comments-style';

const Comments = observer(() => {
  // const [comment, setComment] = useState([]);
  // const [hide, setHide] = useState(true);
  // const [autofocus, setAutofocus] = useState(false);

  // const handleQuickSelect = (event, item) => {
  //   if (event.key === 'Enter') {
  //     if (item) {
  //       onSelect(item);
  //     } else {
  //       createNewCustomer();
  //     }
  //   }
  // };

  return <Container />;
});

export default Comments;
